<template>
  <base-material-card color="primary" icon="mdi-calculator" inline class="mx-auto px-5 py-5">
    <template v-slot:after-heading>
      <div class="display-1 font-weight-light">
        {{ title }}
      </div>
    </template>

    <v-form class="pt-5">
      <v-row align="center" no-gutters class="mx-4">
        <v-col cols="8">
          <validation-provider v-slot="{ errors }" rules="required">
            <v-text-field id="titulo-validacao-baixas" v-model="campos.titulo" label="Título" outlined :error-messages="errors" />
          </validation-provider>
        </v-col>
        <v-col id="date-picker-data-base" class="px-5" cols="4">
          <date-picker v-model="campos.dataBase" label="Data Base" type="month" rules="required|min:7" />
        </v-col>
      </v-row>
    </v-form>
  </base-material-card>
</template>

<script>
  import dateFormatterMixins from '@/mixins/dateFormatterMixins';

  export default {
    name: 'ParametrosValidacaoBaixas',

    components: {
      DatePicker: () => import('@/components/general/DatePicker.vue')
    },

    mixins: [dateFormatterMixins],

    props: {
      item: {
        type: Object,
        default: () => ({
          titulo: '',
          data_base: ''
        })
      },
      title: {
        type: String,
        default: ''
      }
    },

    data() {
      return {
        campos: {
          titulo: '',
          dataBase: ''
        }
      };
    },

    mounted() {
      if (this.$route.params.id) this.fillFields();
    },

    methods: {
      fillFields() {
        this.campos.titulo = this.item.titulo;
        this.campos.dataBase = this.getOnlyDateIgnoringTimestamp(this.item.data_base);
      },

      exportData() {
        return {
          titulo: this.campos.titulo,
          data_base: this.campos.dataBase
        };
      },

      getOnlyDateIgnoringTimestamp(date) {
        if (date && date.length > 10) {
          date = date.substr(0, 10);
        }
        return date;
      }
    },

    watch: {
      item: {
        handler() {
          this.fillFields();
        },
        deep: true,
        immediate: true
      }
    }
  };
</script>

<style>
  .custom-card {
    max-width: 500px; /* Deixa o card mais estreito */
  }
</style>